// extracted by mini-css-extract-plugin
export default {"label":"styles_label__zYFs0","valueWrapper":"styles_valueWrapper__DG--x","value":"styles_value__90KYk","addInfo":"styles_addInfo__Zb7n3"};